import { useContext } from 'react';

import DiscountTag from 'components/common/DiscountTag';
import StrikethroughSkeleton from 'components/common/StrikethroughSkeleton';
import Text from 'components/common/Text';
import { UserContext } from 'components/signUpFunnel/Contexts';
import { formatPricePerServing } from 'helpers/servings';

const PricePerServing = ({ box, includesServingRange }) => {
  const { user } = useContext(UserContext);
  const hasSmsDiscount = user?.smsDiscount && box?.smsIncentivePromo;

  return (
    <div className="flex py-2">
      <Text className="flex-1 pb-2 text-left" htmlElement="dt">
        Price Per Serving
      </Text>
      {box?.promoApplied || hasSmsDiscount ? (
        <Text htmlElement="dd" brandStylesOverrides="textMd text-secondary flex">
          {hasSmsDiscount && <DiscountTag discountText="5% OFF" />}
          {box?.promoApplied && <DiscountTag box={box} />}
          <StrikethroughSkeleton
            strikethroughText={
              includesServingRange
                ? `${box?.pricePerServingLowFormatted} - ${box?.pricePerServingHighFormatted}`
                : box?.pricePerServingFormatted
            }
            textDisplayed={formatPricePerServing(box, hasSmsDiscount)}
            ariaLabel="price per serving"
            containerClassNames={includesServingRange ? 'flex flex-col-reverse justify-end' : ''}
            className={includesServingRange ? '!px-0' : ''}
          />
        </Text>
      ) : (
        <Text htmlElement="dd" brandStylesOverrides="textMd text-secondary">
          {formatPricePerServing(box)}
        </Text>
      )}
    </div>
  );
};

PricePerServing.propTypes = {
  box: PropTypes.shape({
    promoApplied: PropTypes.bool.isRequired,
    pricePerServingFormatted: PropTypes.string.isRequired,
    pricePerServingCents: PropTypes.number.isRequired,
    pricePerServingRange: PropTypes.string,
    pricePerServingLowFormatted: PropTypes.string,
    pricePerServingHighFormatted: PropTypes.string,
    totalRecipes: PropTypes.number,
    promo: PropTypes.shape({
      pricePerServingFormatted: PropTypes.string,
      pricePerServingCents: PropTypes.number,
      subtotalCents: PropTypes.number,
    }),
    smsIncentivePromo: PropTypes.shape({
      subtotalCents: PropTypes.number,
      subtotalFormatted: PropTypes.string,
      pricePerServingFormatted: PropTypes.string,
    }),
  }).isRequired,
  includesServingRange: PropTypes.bool,
};

export default PricePerServing;
